import axios from "axios";
import type { RegisterPartnerData, SpreadsheetsMap } from "./registerPartner.d";

export const registerPartner = async (data: RegisterPartnerData, listName: SpreadsheetsMap) => {
  const url = "/api/register-partner/";

  const headers = {
    "Content-Type": "application/json",
  };

  try {
    return await axios.post(url, { data, listName }, { headers });
  } catch (error) {
    return Promise.reject(error);
  }
};
